import { MantineProvider } from '@mantine/core';
import { theme } from '@src/theme';
import '@mantine/core/styles.css';
import { Authenticator } from '@aws-amplify/ui-react';
import { CompanyInfoProvider } from '@contexts/company-info';
import { OaiThreadProvider } from '@contexts/oai-thread';
import '@aws-amplify/ui-react/styles.css';
import '@aws-amplify/ui-react/styles/base.layer.css';
import AppRoutes from '@src/routes';
import './sentry-override.css';

function App() {
  return (
    <MantineProvider theme={theme}>
      <Authenticator.Provider>
        <CompanyInfoProvider>
          <OaiThreadProvider>
            <AppRoutes />
          </OaiThreadProvider>
        </CompanyInfoProvider>
      </Authenticator.Provider>
    </MantineProvider>
  );
}

export default App;
